/* Oasly: Subscription / One-time purchase toggle on the landing-page pricing block.
   The Webflow interaction for the "one-time" tab was missing (also broken on www.oasly.es). 27.10.26 */
(function(){
  var ON_BG = 'rgb(0, 109, 164)', OFF_FG = 'rgb(55, 71, 79)';
  var HIDE = 'position:absolute;z-index:-1;opacity:0;visibility:hidden;pointer-events:none';
  var SHOW = 'position:relative;z-index:2;opacity:1;visibility:visible';
  function setup(menu){
    var block = menu.closest('.section_plan-block');
    if (!block) return;
    var t1 = menu.querySelector('.tab1-subscription'), t2 = menu.querySelector('.tab2-subscription');
    var sub = block.querySelector('.is-subscription-testing'), one = block.querySelector('.is-time-purchase-testing-wrap');
    if (!t1 || !t2 || !sub || !one) return;
    function paint(t, on){
      t.style.backgroundColor = on ? ON_BG : 'transparent';
      t.style.color = on ? '#fff' : OFF_FG;
      var kids = t.querySelectorAll('*');
      for (var i = 0; i < kids.length; i++) kids[i].style.color = on ? '#fff' : OFF_FG;
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    function show(oneTime){
      paint(t1, !oneTime); paint(t2, oneTime);
      sub.style.cssText = oneTime ? HIDE : SHOW;
      one.style.cssText = oneTime ? SHOW : HIDE;
    }
    t1.setAttribute('role', 'button'); t2.setAttribute('role', 'button');
    t1.addEventListener('click', function(e){ e.preventDefault(); e.stopImmediatePropagation(); show(false); }, true);
    t2.addEventListener('click', function(e){ e.preventDefault(); e.stopImmediatePropagation(); show(true); }, true);
    show(false);
  }
  function init(){
    var menus = document.querySelectorAll('.subscription-tab-menu.is-texting');
    for (var i = 0; i < menus.length; i++) setup(menus[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Oasly: "Chat ..." buttons with href="#" did nothing (their Webflow interaction was missing, also on Webflow).
   Desktop (>=992px): open the QR popup (.form_block); close via its X or the backdrop.
   Mobile: turn the button into the page's WhatsApp link before the click completes, so WhatsApp opens
   and the Google Ads / GA4 WhatsApp click is tracked by oasly-tracking. Runs on window capture so it
   precedes the tracking listener on document. 29.10.26 */
(function(){
  var RX = /chat|agend|empez|start|book|schedule|whatsapp/i;
  function fb(){ return document.querySelector('.form_block'); }
  function wa(){ var a = document.querySelector('.form_block a[href*="wa.me"]') || document.querySelector('a[href*="wa.me"]'); return a ? a.href : null; }
  window.addEventListener('click', function(e){
    var t = e.target; if (!t || !t.closest) return;
    var f = fb();
    if (t.closest('.form_block .cross_icon') || (f && t === f)) { if (f) f.style.display = 'none'; return; }
    var a = t.closest('a[href="#"]');
    if (!a || a.closest('.form_block') || !RX.test(a.textContent || '')) return;
    var w = wa(); if (!w) return;
    if (f && window.matchMedia('(min-width: 992px)').matches) { e.preventDefault(); f.style.display = 'flex'; return; }
    a.setAttribute('href', w); a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener');
  }, true);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') { var f = fb(); if (f) f.style.display = 'none'; } });
})();
